import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { Logo } from '@/components/brand/Logo';
import { SiteFooter } from '@/components/landing/SiteFooter';
import { PageContainer } from '@/components/landing/sections';

/**
 * ヘルプの外枠。索引と記事の両方がこれを被る。
 *
 * ログイン状態は props で受ける。ログイン済みの人に「14日間無料で試す」を
 * 出したくないのと、戻り先がロールで違うため。**戻り先のパスをここに
 * 直書きしない**——リダイレクト先は main.tsx の `home` 1 箇所で決める。
 */
export interface HelpChromeProps {
  signedIn: boolean;
  /** ログイン済みのときの戻り先。ロールごとに必ず開ける画面 */
  home: string;
}

export function HelpLayout({
  signedIn,
  home,
  children,
}: HelpChromeProps & { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-surface text-ink">
      <header className="border-b border-line bg-surface-raised">
        <PageContainer className="flex items-center justify-between gap-3 py-3.5 sm:py-5">
          <div className="flex items-center gap-3 sm:gap-4">
            <Link to="/" aria-label="INOU トップへ">
              {/* 公開ページのヘッダーは LP と同じ寸法 (狭い幅で 36、640px 以上で 48)。並べて見たときに揃う */}
              <Logo height={48} className="h-9 w-auto text-brand-500 sm:h-12" />
            </Link>
            <Link to="/help" className="font-mono text-xs tracking-[0.14em] text-ink-subtle">
              HELP
            </Link>
          </div>
          {signedIn ? (
            <Link to={home} className="text-sm text-ink-muted transition-colors hover:text-ink">
              アプリに戻る
            </Link>
          ) : (
            <Link to="/" className="text-sm text-ink-muted transition-colors hover:text-ink">
              トップへ戻る
            </Link>
          )}
        </PageContainer>
      </header>

      <main className="flex-1">{children}</main>

      <SiteFooter signedIn={signedIn} />
    </div>
  );
}
